


import Vue, { PropType } from 'vue'
import { formatMoneyFilter, formatMoneySquareFilter } from '@/plugins/filters'
import { MapMarker } from '@/interfaces/gmap/Map'

export default Vue.extend({
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: Object as PropType<MapMarker>,
    location: String,
    priceAvg: Number,
    priceTotalAvg: Number,
  },
  mounted() {
    const marker = new this.google.maps.Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      icon: new this.google.maps.MarkerImage(
        this.marker.icon,
        null,
        null,
        new this.google.maps.Point(35, 50),
        new this.google.maps.Size(70, 70)
      ),
    })

    const infoWindow = new this.google.maps.InfoWindow({
      content: `
        <div class="transaction-window__card">
          <div class="transaction-window__info">
            <span><strong>${this.location}</strong></span><br/>
            <span>Průměrná cena z m²: ${formatMoneySquareFilter(
              this.priceAvg
            )}</span><br/>
            <span>Průměrná cena: ${formatMoneyFilter(this.priceTotalAvg)}</span>
          </div>
        </div>`,
    })

    marker.addListener('click', () => {
      infoWindow.open(this.map, marker)
    })
  },
})
